var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"justify-content-end d-flex"},[_c('md-button',{staticClass:"md-raised md-primary",on:{"click":_vm.handlePatientSave}},[_vm._v(" Save ")])],1),_c('PatientHistory')],1)}
var staticRenderFns = []

export { render, staticRenderFns }